import React, { Ref } from 'react'

import Select, { SelectProps } from 'components/ui/Select/Select'

const InvitationStatusSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const options = [
      { value: 'pending', text: 'Pending' },
      { value: 'accepted', text: 'Accepted' },
      { value: 'joined', text: 'Joined' }
    ]

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options} {...props} ref={ref} />
      </div>
    )
  }
)

export default InvitationStatusSelect
